import Vue from 'vue'
import http from 'axios'

http.defaults.baseURL = process.env.VUE_APP_API_URL
http.defaults.headers.common = { 'Authorization': `${process.env.VUE_APP_TOKEN}` }

Vue.prototype.$http = http
export default http
